<mmx-breadcrumbs
  *ngIf="!embedded"
  [breadcrumbs]="[patient, appointment, invoice]"
></mmx-breadcrumbs>

<mmx-invoice-card
  *ngIf="invoice && invoice.estimate"
  [invoice]="invoice"
  [patient]="patient"
  [estimate]="estimate"
></mmx-invoice-card>

<mat-card
  *ngIf="invoice && !invoice.estimate"
  class="default has-progress-bar"
  [ngClass]="invoice?.id ? 'card-has-subtitle' : ''"
>
  <mat-progress-bar mode="determinate"></mat-progress-bar>

  <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
    <span [class.text-warn]="invoice.status === STATUS.VOID">
      <span *ngIf="invoice.status === STATUS.DRAFT" class="text-warn">
        {{ 'common.draft' | translate }}
      </span>
      <ng-container *ngIf="invoice.status === STATUS.VOID">
        {{ 'common.voided' | translate }}
      </ng-container>
      {{ 'common.invoice' | translate }}
      {{ invoice.shortId | shortId }}
    </span>

    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="1rem">
      <button
        mat-stroked-button
        *ngIf="!editable && invoice.status !== STATUS.VOID"
        (click)="void()"
        color="warn"
      >
        <mat-icon>delete</mat-icon>
        <span>{{ 'common.void' | translate }}</span>
      </button>

      <button
        mat-stroked-button
        *ngIf="editable && invoice.id && invoice.id.length > 0"
        (click)="delete()"
        color="warn"
      >
        <mat-icon>delete</mat-icon>
        <span>{{ 'common.delete' | translate }}</span>
      </button>

      <button
        mat-stroked-button
        *ngIf="!editable && invoice.status !== STATUS.VOID && invoice.status !== STATUS.INTERIM"
        (click)="download()"
      >
        <mat-icon>print</mat-icon>
        <span>{{ 'common.print' | translate }}</span>
      </button>

      <button
        mat-stroked-button
        *ngIf="!editable && invoice.status !== STATUS.VOID && invoice.status !== STATUS.INTERIM"
        [matMenuTriggerFor]="invoiceSendMenu"
      >
        <mat-icon>send</mat-icon>
        <span>{{ 'common.send' | translate }}</span>
      </button>

      <!--
        Draft button disabled for now
        because we currently don't have a way
        to list/view draft invoices
      -->
      <!-- <button mat-stroked-button *ngIf="editable" (click)="save()">
        <mat-icon>save</mat-icon>
        <span>
          {{ 'common.save' | translate }} {{ 'common.draft' | translate }}
        </span>
      </button> -->

      <button
        mat-stroked-button
        *ngIf="editable"
        (click)="confirm()"
        matTooltip="Confirm invoice, Med-Metrix will be collect the amount due at time of patient's appointment"
      >
        <mat-icon>done</mat-icon>
        <span>{{ 'common.confirm' | translate }}</span>
      </button>
    </div>
  </mat-card-title>

  <mmx-invoice-subtitle
    *ngIf="invoice?.id"
    [invoice]="invoice"
  ></mmx-invoice-subtitle>

  <mat-menu #invoiceSendMenu="matMenu">
    <button
      mat-menu-item
      [disabled]="!canSendEmail(invoice)"
      (click)="openSendDialog('link', 'email')"
    >
      <mat-icon>send</mat-icon>
      {{ 'invoice-card.button-send-link' | translate }}
    </button>
    <button
      mat-menu-item
      [disabled]="!canSendSms(invoice)"
      (click)="openSendDialog('link', 'sms')"
    >
      <mat-icon>send</mat-icon>
      {{ 'invoice-card.button-send-sms' | translate }}
    </button>
    <mat-divider></mat-divider>
    <button
      mat-menu-item
      [disabled]="!canSendEmail(invoice)"
      (click)="openSendDialog('pdf')"
      matTooltip="Sends the invoice as a PDF to the patient"
    >
      <mat-icon>send</mat-icon>
      Send document
    </button>
  </mat-menu>

  <ng-container *ngIf="invoice && invoice.status !== STATUS.INTERIM">
    <table mat-table style="width: 100%" [dataSource]="items">
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef class="text-left pl-3">
          {{ 'common.item' | translate }}
        </th>
        <td mat-cell *matCellDef="let item" class="text-left">
          <ng-container *ngIf="editable">
            <mat-form-field hideRequiredMarker floatLabel="never">
              <mat-label>{{ 'common.description' | translate }}</mat-label>
              <input
                matInput
                type="text"
                required
                [(ngModel)]="item.description"
              />
            </mat-form-field>
          </ng-container>

          <div *ngIf="!editable" class="pl-3">{{
            item.description
          }}</div>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef class="text-right">Qty</th>
        <td mat-cell *matCellDef="let item" class="text-right">
          <ng-container *ngIf="editable">
            <mat-form-field hideRequiredMarker floatLabel="never">
              <mat-label>Qty</mat-label>
              <input
                matInput
                type="number"
                min="0"
                [(ngModel)]="item.quantity"
                (change)="sumTotal(item)"
              />
            </mat-form-field>
          </ng-container>

          <ng-container *ngIf="!editable">
            {{ item.quantity }}
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="unit_amount">
        <th mat-header-cell *matHeaderCellDef class="text-right">
          {{ 'invoice-card.unit-amount' | translate }}
        </th>
        <td mat-cell *matCellDef="let item" class="text-right">
          <ng-container *ngIf="editable">
            <mat-form-field hideRequiredMarker floatLabel="never">
              <mat-label>{{ 'invoice-card.unit-amount' | translate }}</mat-label>
              <input
                matInput
                type="number"
                min="0"
                required
                [(ngModel)]="item.unit_amount"
                (change)="sumTotal(item)"
              />
              <span matTextPrefix>$&nbsp;</span>
            </mat-form-field>
          </ng-container>

          <ng-container *ngIf="!editable">
            {{ item.unit_amount | currency: item.currency }}
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <div fxLayout="column" class="text-right" *ngIf="invoice.showDetails">
            <strong>{{ 'common.subtotal' | translate }}</strong>
            <strong>{{ 'common.total' | translate }}</strong>
            <strong>{{ 'invoice-card.amount-due' | translate }}</strong>
            <strong>{{ 'invoice-card.amount-paid' | translate }}</strong>
            <strong>{{ 'invoice-card.amount-remaining' | translate }}</strong>
            <strong *ngIf="invoice.amountRemaining < 0">{{
              'invoice-card.refund-due' | translate
            }}</strong>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef class="text-right pr-3">
          {{ 'common.amount' | translate }}
        </th>
        <td mat-cell *matCellDef="let item" class="text-right pr-3">
          <ng-container *ngIf="item.amount == null || item.amount === 0">N/A</ng-container>
          <ng-container *ngIf="item.amount > 0">{{
            item.amount | currency: item.currency
          }}</ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <div fxLayout="column" class="text-right" *ngIf="invoice.showDetails">
            <span>{{ invoice.subtotal | currency: invoice.currency }}</span>
            <span>{{ invoice.total | currency: invoice.currency }}</span>
            <span>{{ invoice.amountDue | currency: invoice.currency }}</span>
            <span>{{ invoice.amountPaid | currency: invoice.currency }}</span>
            <ng-container
              *ngIf="invoice.amountRemaining >= 0; else negativeAmountRemaining"
            >
              <span>{{
                invoice.amountRemaining | currency: invoice.currency
              }}</span>
            </ng-container>
            <ng-template #negativeAmountRemaining>
              <span>{{ 0 | currency: invoice.currency }}</span>
              <span>{{
                invoice.amountRemaining * -1 | currency: invoice.currency
              }}</span>
            </ng-template>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td
          mat-cell
          *matCellDef="let item"
          class="text-right"
          style="width: 30px"
        >
          <button mat-icon-button [matMenuTriggerFor]="menu" class="on-hover">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <!-- <button mat-menu-item>Discountable</button> -->
            <div mat-menu-item (click)="$event.stopPropagation()">
              <mat-slide-toggle
                matTooltip="Whether coupon codes can apply to this item"
                [(ngModel)]="item.discountable"
                >Discountable</mat-slide-toggle
              >
            </div>
            <button
              mat-menu-item
              *ngIf="items.data.length > 1"
              (click)="removeLineItem(item)"
            >
              <mat-icon color="warn">delete</mat-icon>
              Remove
            </button>
          </mat-menu>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <tr
        mat-row
        [@addRowAnimation]=""
        *matRowDef="let item; columns: columnsToDisplay"
      ></tr>
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-footer-row *matFooterRowDef="columnsToDisplay"></tr>
    </table>
  </ng-container>

  <mat-card-content *ngIf="invoice && invoice.status === STATUS.DRAFT">
    <div fxLayout="row">
      <div fxFlex="grow">
        <button
          mat-button
          color="primary"
          (click)="addLineItem()"
          matTooltip="Add Line Item"
          *ngIf="editable"
        >
          <mat-icon>add</mat-icon>
          Add another item
        </button>
      </div>
      <!-- <button mat-button *ngIf="!hasDefaultTax">
        Add Default Tax
      </button>

      <div fxLayout="row" fxLayoutAlign="space-between" *ngIf="hasDefaultTax || hasTax">
        <strong>Tax</strong>
        <span>{{ invoice.tax | currency:invoice.currency }}</span>
      </div> -->
      <div fxFlex="50px"></div>
    </div>

    <div fxLayout="column" *ngIf="editable">
      <mat-form-field>
        <mat-label>Memo</mat-label>
        <textarea
          matInput
          [(ngModel)]="invoice.template.description"
        ></textarea>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Footer</mat-label>
        <textarea matInput [(ngModel)]="invoice.template.footer"></textarea>
      </mat-form-field>

      <div fxFlex fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="1em">
        <mat-form-field fxFlex="135px">
          <mat-label>Payment due after (days)</mat-label>
          <input matInput type="number" [(ngModel)]="invoice.template.due" (input)="onDueDaysChange($event.target.value)" />
        </mat-form-field>
        <span>
          Invoice due date is {{ invoice.template.due }} days after confirmation - {{ invoice.dueDate | momentDate }}
        </span>
      </div>

      <!--
        Disabled for now because these fields are not being used/supported
      -->
      <!-- <div class="checkbox-form-field" fxFlex *ngIf="paymentPlansEnabled">
        <mat-checkbox
          [(ngModel)]="invoice.options.enablePaymentPlan"
          color="primary"
        >
          <span>Offer payment plan</span>
        </mat-checkbox>
      </div>

      <div class="checkbox-form-field" fxFlex *ngIf="promptPayDiscountEnabled">
        <mat-checkbox
          [(ngModel)]="invoice.options.enablePromptPayDiscount"
          color="primary"
        >
          <span>Offer prompt payment discount</span>
        </mat-checkbox>
      </div> -->
    </div>
  </mat-card-content>
</mat-card>

<mmx-transactions-card
  *ngIf="
    invoice &&
    invoice.id &&
    invoice.status !== STATUS.DRAFT &&
    (invoice.status !== STATUS.VOID ||
      (transactions && transactions.length > 0))
  "
  [invoice]="invoice"
  [patient]="patient"
  [transactions]="transactions"
></mmx-transactions-card>

<mmx-charge-card
  *ngIf="
    clinic?.modules.payment &&
    invoice &&
    invoice.id &&
    invoice.status !== STATUS.DRAFT &&
    invoice.status !== STATUS.VOID
  "
  [patient]="patient"
  [invoice]="invoice"
  [chargeAmount]="invoice.amountRemaining"
  (newCharge)="newUpdateFromCharge($event)">
</mmx-charge-card>
